export enum FormatType {
	CNPJ = 'cnpj',
	PHONE = 'phone',
	CEP = 'cep',
}
